export const ru = {
    about: 'Подробнее'
};
